import React, { useState } from "react";
import { Grid, Typography, TextField, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import LoadingButton from "@mui/lab/LoadingButton";
import { useNavigate } from "react-router-dom";
import InputAdornment from "@mui/material/InputAdornment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
// import Footer from "../../component/Footer/Index";
import AiImage from "../../assets/images/AiImage.svg";
import summaryService from "../../services/summary";
import CustomizedSnackbars from "../../component/Snackbar/Index";
import Footer from "../../component/Footer/Footer";
import { TOKEN } from "../../store/actions";

//npm

import * as Yup from "yup";
import { Form, Formik } from "formik";
import { useDispatch } from "react-redux";

//projects

function Login() {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbarTitle, setOpenSnackbarTitle] = useState(false);
  const [allvalues, setValues] = useState({});

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFormSubmit = async (value) => {
    try {
      const response = await summaryService.postSignUp(value);
      if (response.ok) {
        // navigate("/pricing");
        setOpenSnackbar(true);
        setOpenSnackbarTitle("You are successfully Register in");
  
        dispatch({ type: TOKEN, token: response?.data?.token});
        window.location.href = "/pricing";
      } else {
        if (Object.keys(response?.data).length > 0) {
          setOpenSnackbar(true);
          setOpenSnackbarTitle(response?.data?.message);
        } else {
          setOpenSnackbar(true);
          setOpenSnackbarTitle("Some thing went wrong");
        }
      }
    } catch (error) {
      console.log(error);
      setOpenSnackbar(true);
    }
  };

  return (
    <div>
      <Formik
        enableReinitialize
        initialValues={{
          fname: "",
          lname: "",
          email: "",
          password: "",
        }}
        validationSchema={Yup.object().shape({
          fname: Yup.string().nullable().trim().max(50).required("First Name Required"),
          lname: Yup.string().nullable().trim().required("Last Name Required"),
          email: Yup.string().nullable().trim().email().required("Email Required"),
          password: Yup.string().trim()
            .required("Password Required")
            .matches(
              /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
              "Password must contain at least 8 characters, one uppercase, one lower case, one number and one special case character"
            )

        })}
        onSubmit={(values) => {
          handleFormSubmit(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          onSubmit,
          getFieldProps,
        }) => (
          <Form>
            <Grid container>
              <Grid
                xs={12}
                sx={{
                  background: "#caf0f8",
                  height: "300px",
                  borderRadius: "14% 0% 46% 58% / 0% 43% 36% 32% ",
                  position: "relative",
                }}
              />
              <Grid container sx={{ position: "absolute !important" }}>
                <Grid xs={12} textAlign="center">
                  <Box className={classes.logoAlign}>
                    <Box
                      sx={{
                        display: "flex",
                        padding: "1rem",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        className={classes.imgRes}
                        src={AiImage}
                        alt="AiImage"
                        height="auto"
                        onClick={() => navigate("/login")}
                        style={{ cursor: "pointer" }}
                      />
                    </Box>
                  </Box>
                </Grid>

                <Grid
                  xs={12}
                // sx={{
                //   background: "#caf0f8",
                //   borderRadius: "14% 0% 46% 58% / 0% 43% 36% 32% ",
                //   position: "obsolute",
                //   height: "250px",
                // }}
                >
                  <Box className={classes.loginBlock}>
                    <Box className={classes.contentBlock}>
                      <Box mb={2} mt={1}>
                        <Typography variant="h3" className={classes.details}>
                          Sign Up
                        </Typography>

                        <Typography className={classes.details}>
                          Create your account
                        </Typography>
                      </Box>
                      <Box mb={2}>
                        <TextField
                          className={classes.textFieldWidth}
                          fullWidth

                          value={values.fname}
                          name="fname"
                          id="outlined-basic"
                          label="First Name*"
                          variant="outlined"
                          type="text"
                          error={Boolean(touched.fname && errors.fname)}
                          // value={values.projectName}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          helperText={touched.fname && errors.fname}
                          // aria-describedby="outlined-weight-helper-text"
                          // inputProps={{ "aria-label": "projectName" }}
                          aria-describedby="outlined-weight-helper-text"
                        />
                      </Box>
                      <Box mb={2}>
                        <TextField
                          className={classes.textFieldWidth}
                          fullWidth

                          value={values.lname}
                          name="lname"
                          id="outlined-basic"
                          label="Last Name*"
                          variant="outlined"
                          type="text"

                          // value={values.projectName}
                          error={Boolean(touched.lname && errors.lname)}
                          // value={values.projectName}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          helperText={touched.lname && errors.lname}

                          // aria-describedby="outlined-weight-helper-text"
                          // inputProps={{ "aria-label": "projectName" }}
                          aria-describedby="outlined-weight-helper-text"
                        />
                      </Box>
                      <Box mb={2}>
                        <TextField
                          className={classes.textFieldWidth}
                          fullWidth

                          value={values.email}
                          name="email"
                          id="outlined-basic"
                          label="Email*"
                          variant="outlined"
                          type="email"
                          error={Boolean(touched.email && errors.email)}
                          // value={values.projectName}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          helperText={touched.email && errors.email}
                          // aria-describedby="outlined-weight-helper-text"
                          // inputProps={{ "aria-label": "projectName" }}
                          aria-describedby="outlined-weight-helper-text"
                        />
                      </Box>
                      <Box mb={2}>
                        <TextField
                          className={classes.textFieldWidth}

                          // autoComplete="current-password"
                          type={showPassword ? "text" : "password"}
                          label="Password*"
                          {...getFieldProps("password")}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={handleClickShowPassword}
                                  onMouseDown={handleMouseDownPassword}
                                >
                                  {showPassword ? (
                                    <VisibilityOff />
                                  ) : (
                                    <Visibility />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          error={Boolean(touched.password && errors.password)}
                          helperText={touched.password && errors.password}
                        />
                        {/* <TextField
                      className={classes.textFieldWidth}
                      
                      fullWidth
                      value={values.password}
                      name="password"
                      id="outlined-basic"
                      label="password"
                      variant="outlined"
                      type="password"
                      error={Boolean(touched.password && errors.password)}
                      // value={values.projectName}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      helperText={touched.password && errors.password}
                      
                      aria-describedby="outlined-weight-helper-text"
                    /> */}
                      </Box>

                      <Box mb={1}>
                        <LoadingButton

                          type="submit"
                          className={classes.textFieldWidth}
                          sx={{ padding: "12px" }}
                          fullWidth
                          variant="contained"
                          color="primary"
                        >
                          Sign Up
                        </LoadingButton>
                      </Box>

                      <Typography
                        onClick={() => navigate("/login")}
                        className={classes.signIn}
                      >
                        Already have an account?
                        <span style={{ color: "#0077B6" }}> Sign in</span>
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid xs={12} sx={{ marginTop: "3rem" }}>
                  <Footer />
                </Grid>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>

      <CustomizedSnackbars
        open={openSnackbar}
        close={() => setOpenSnackbar(false)}
        title={openSnackbarTitle}
      />
    </div>
  );
}

export default Login;
const useStyles = makeStyles((theme) => ({
  imgRes: {
    width: "250px",
    [theme.breakpoints.down("sm")]: {
      width: "250px",
    },
  },
  logoAlign: {
    margin: "3rem 0rem 1rem 0rem",
  },
  textFieldWidth: {
    width: "370px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  //   gridContainer: {
  //     background: "#F1F6FD 0% 0% no-repeat padding-box",
  //     padding: "1rem",
  //     boxShadow: "0px 3px 6px #00000029",
  //     [theme.breakpoints.down("md")]: {
  //       display: "none",
  //     },
  //   },
  loginBlock: {
    display: "flex",
    justifyContent: "center",
    margin: "auto",
    marginTop: "1rem",
  },
  contentBlock: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
    opacity: 1,
    padding: "1rem 2rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0rem 1rem",
    },
  },

  grid: {
    boxShadow: "0px 3px 6px #00000029",
    opacity: 100,
    background: "#FFFFFF",
    textAlign: "center",
    [theme.breakpoints.down("md")]: {
      paddingBottom: "4rem",
      borderRadius: "16px",
    },
  },
  container: {
    display: "flex",
    justifyContent: "center",
  },

  details: {
    fontWeight: "bold",
    textAlign: "center",
  },
  signIn: {
    fontWeight: "bold",
    textAlign: "center",
    color: "orange",
    marginTop: "1rem",
    lineHeight: 1.5,
    letterSpacing: "1px",
    cursor: "pointer",
  },
}));
